import styles from './follower-count.module.css';

type Props = {
  readonly value: number;
};

export function CompanyInformationFollowCount({value}: Props) {
  return (
    <p className={styles.followerCount}>
      <span className={styles.value}>{value.toLocaleString()}</span>
      <span className={styles.unit}>フォロワー</span>
    </p>
  );
}
